"use client";

import Link from "@/components/ui/intent-link";

import { AssetImage } from "@/components/optilase/asset-image";
import { Button } from "@/components/ui/button";
import { useBookingDrawer } from "@/lib/booking-context";
import { BRAND } from "@/lib/brand";
import { regionFromPathname, regionPath } from "@/lib/region";
import { usePublicPathname } from "@/lib/public-pathname";

export default function LpHeader() {
  const { setOpen: setBookingOpen } = useBookingDrawer();
  const region = regionFromPathname(usePublicPathname() || "/");

  return (
    <header className="relative z-50 w-full bg-white">
      <div className="relative mx-auto flex h-16 max-w-360 items-center justify-between px-5 lg:h-20 lg:px-20">
        <Link href={regionPath("/", region)} aria-label={`${BRAND.name} home`} className="shrink-0">
          <AssetImage
            src="/assets/logo/optilase/logo.svg"
            alt={BRAND.logoAlt}
            width={125}
            height={45}
            className="h-8 w-auto lg:h-10"
            priority
          />
        </Link>

        <Button
          variant="orange"
          onClick={() => setBookingOpen(true, "lp-header")}
          className="h-11 px-5 text-sm lg:h-12 lg:px-6 lg:text-base"
        >
          Book consultation
        </Button>
      </div>
    </header>
  );
}
